/* cls-pdp.js — Celestium Product Detail Page interactivity (source: Celestium Product Detail.dc.html) */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-cls-pdp]');
    if (!root) return;

    var state = { size: null, color: root.querySelector('[data-cls-color-btn]') ? root.querySelector('[data-cls-color-btn]').dataset.colorName : '', qty: 1, active: 0 };

    /* ---------- Toast ---------- */
    var toastEl = document.querySelector('[data-cls-toast]');
    var toastTimer = null;
    function flash(text) {
      if (!toastEl) return;
      toastEl.querySelector('[data-cls-toast-text]').textContent = text;
      toastEl.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
    }

    /* ---------- Gallery: thumbs + stage + mobile thumbs ---------- */
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cls-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cls-thumb]'));
    var mobileThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cls-mobile-thumb]'));
    var counterEls = Array.prototype.slice.call(document.querySelectorAll('[data-cls-counter]'));
    var total = slides.length;

    function setActive(i) {
      if (total === 0) return;
      state.active = ((i % total) + total) % total;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === state.active); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === state.active); });
      mobileThumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === state.active); });
      counterEls.forEach(function (c) { c.textContent = '0' + (state.active + 1) + ' / 0' + total; });
    }
    setActive(0);

    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { setActive(n); }); });
    mobileThumbs.forEach(function (t, n) { t.addEventListener('click', function () { setActive(n); }); });

    var stage = root.querySelector('[data-cls-stage]');
    if (stage) {
      stage.addEventListener('click', function () { openLightbox(); });

      var touchX = null;
      stage.addEventListener('touchstart', function (e) { touchX = e.touches && e.touches[0] ? e.touches[0].clientX : null; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var end = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : touchX;
        var dx = end - touchX;
        if (Math.abs(dx) > 44) setActive(state.active + (dx < 0 ? 1 : -1));
        touchX = null;
      }, { passive: true });
    }

    /* ---------- Lightbox ---------- */
    var lbScrim = document.querySelector('[data-cls-lb-scrim]');
    var lbPanel = document.querySelector('[data-cls-lb-panel]');
    var lbSlides = Array.prototype.slice.call(document.querySelectorAll('[data-cls-lb-slide]'));

    function syncLbSlides() { lbSlides.forEach(function (s, n) { s.classList.toggle('is-active', n === state.active); }); }

    function openLightbox() {
      syncLbSlides();
      if (lbScrim) lbScrim.classList.add('is-open');
      if (lbPanel) lbPanel.classList.add('is-open');
    }
    function closeLightbox() {
      if (lbScrim) lbScrim.classList.remove('is-open');
      if (lbPanel) lbPanel.classList.remove('is-open');
    }
    document.querySelectorAll('[data-cls-lb-close], [data-cls-lb-scrim]').forEach(function (b) { b.addEventListener('click', closeLightbox); });
    document.querySelectorAll('[data-cls-lb-prev]').forEach(function (b) { b.addEventListener('click', function () { setActive(state.active - 1); syncLbSlides(); }); });
    document.querySelectorAll('[data-cls-lb-next]').forEach(function (b) { b.addEventListener('click', function () { setActive(state.active + 1); syncLbSlides(); }); });

    if (lbPanel) {
      var lbTouchX = null;
      lbPanel.addEventListener('touchstart', function (e) { lbTouchX = e.touches && e.touches[0] ? e.touches[0].clientX : null; }, { passive: true });
      lbPanel.addEventListener('touchend', function (e) {
        if (lbTouchX === null) return;
        var end = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : lbTouchX;
        var dx = end - lbTouchX;
        if (Math.abs(dx) > 44) { setActive(state.active + (dx < 0 ? 1 : -1)); syncLbSlides(); }
        lbTouchX = null;
      }, { passive: true });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeLightbox(); closeSizeGuide(); }
      if (lbPanel && lbPanel.classList.contains('is-open')) {
        if (e.key === 'ArrowRight') { setActive(state.active + 1); syncLbSlides(); }
        if (e.key === 'ArrowLeft') { setActive(state.active - 1); syncLbSlides(); }
      }
    });

    /* ---------- Colour swatches (custom cls.swatch metafield products) ---------- */
    var colorBtns = Array.prototype.slice.call(root.querySelectorAll('[data-cls-color-btn]'));
    var colorNameEl = root.querySelector('[data-cls-color-name]');
    colorBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        colorBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.color = btn.dataset.colorName || '';
        if (colorNameEl) colorNameEl.textContent = state.color;
      });
    });

    /* ---------- Size selection (custom cls.swatch metafield products) ---------- */
    var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-cls-size-btn]'));
    var stockLineEl = root.querySelector('[data-cls-stock-line]');
    sizeBtns.forEach(function (btn) {
      if (btn.disabled) return;
      btn.addEventListener('click', function () {
        sizeBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.size = btn.dataset.size;
        if (stockLineEl) stockLineEl.textContent = (btn.dataset.stockLabel || 'Available') + ' in ' + state.size;
      });
    });

    /* ---------- Generic variant picker (products without a cls.swatch metafield,
       driven by the product's real Shopify options/variants) ---------- */
    var variantsJsonEl = root.querySelector('[data-cls-variants-json]') || document.querySelector('[data-cls-variants-json]');
    var genericGroups = Array.prototype.slice.call(document.querySelectorAll('[data-cls-generic-opt-group]'));
    if (variantsJsonEl && genericGroups.length) {
      var variants = [];
      try { variants = JSON.parse(variantsJsonEl.textContent || '[]'); } catch (e) { variants = []; }

      var addBtnEl = root.querySelector('[data-cls-add-btn]');
      var priceEl = document.querySelector('[data-cls-price]');
      var comparePriceEl = document.querySelector('[data-cls-compare-price]');
      var availTextEl = document.querySelector('[data-cls-avail-text]');
      var stickyPriceEl = document.querySelector('[data-cls-sticky-price]');
      var selectLineEl = document.querySelector('[data-cls-generic-select-line]');
      var selected = {}; // option position (1-based) -> value

      function setGenericColorName(btn) {
        var colorName = btn.getAttribute('data-color-name');
        if (!colorName) return;
        var block = btn.closest('.cls-p-opt-block');
        var nameEl = block ? block.querySelector('[data-cls-generic-color-name]') : null;
        if (nameEl) nameEl.textContent = colorName;
      }

      // Pre-select the first available combination so the button starts usable.
      genericGroups.forEach(function (group) {
        var pos = group.getAttribute('data-option-position');
        var firstBtn = group.querySelector('[data-cls-generic-opt-btn]');
        if (firstBtn) {
          firstBtn.classList.add('is-active');
          selected[pos] = firstBtn.getAttribute('data-value');
          setGenericColorName(firstBtn);
        }
      });

      function money(cents) {
        try {
          var amount = (cents / 100);
          var parts = amount.toFixed(2).split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          return parts[0] + ',' + parts[1] + ' Kč';
        } catch (e) { return '' + cents; }
      }

      function findMatch() {
        var positions = Object.keys(selected);
        return variants.filter(function (v) {
          return positions.every(function (pos) {
            var key = 'option' + pos;
            return v[key] === selected[pos];
          });
        })[0] || null;
      }

      function applyMatch() {
        var match = findMatch();
        if (!match) {
          if (selectLineEl) selectLineEl.textContent = 'Tato kombinace není dostupná';
          if (addBtnEl) addBtnEl.setAttribute('disabled', 'disabled');
          return;
        }
        if (addBtnEl) {
          addBtnEl.removeAttribute('disabled');
          addBtnEl.setAttribute('data-variant-id', match.id);
          var label = addBtnEl.querySelector('[data-cls-add-label]');
          var priceLabel = 'Přidat do košíku — ' + money(match.price * 100);
          addBtnEl.setAttribute('data-price-label', priceLabel);
          if (label) label.textContent = priceLabel;
        }
        if (priceEl) priceEl.textContent = money(match.price * 100);
        if (comparePriceEl) {
          if (match.compare_at_price && parseFloat(match.compare_at_price) > parseFloat(match.price)) {
            comparePriceEl.textContent = money(match.compare_at_price * 100);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
        if (stickyPriceEl) stickyPriceEl.textContent = money(match.price * 100);
        if (availTextEl) availTextEl.textContent = match.available ? 'Skladem — expedice do 24 hodin' : 'Aktuálně nedostupné';
        if (selectLineEl) selectLineEl.textContent = match.available ? 'Vybráno: ' + Object.keys(selected).map(function (p) { return selected[p]; }).join(' / ') : 'Vybraná varianta není skladem';
      }

      genericGroups.forEach(function (group) {
        var pos = group.getAttribute('data-option-position');
        var btns = Array.prototype.slice.call(group.querySelectorAll('[data-cls-generic-opt-btn]'));
        btns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            btns.forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            selected[pos] = btn.getAttribute('data-value');
            setGenericColorName(btn);
            applyMatch();
          });
        });
      });

      applyMatch();
    }

    /* ---------- Add to Bag (always quantity 1 — no quantity selector) ---------- */
    function addToCart(variantId, qty, btn) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      }).then(function (res) {
        if (!res.ok) throw new Error('add-to-cart failed');
        return res.json();
      });
    }

    var addBtn = root.querySelector('[data-cls-add-btn]');
    if (addBtn) {
      var spinner = addBtn.querySelector('[data-cls-add-spinner]');
      var check = addBtn.querySelector('[data-cls-add-check]');
      var label = addBtn.querySelector('[data-cls-add-label]');
      var busy = false;

      addBtn.addEventListener('click', function () {
        if (busy || addBtn.hasAttribute('disabled')) return;
        if (sizeBtns.length && !state.size) { flash('Choose a size to continue'); return; }
        var variantId = addBtn.dataset.variantId;
        var basePrice = addBtn.dataset.priceLabel || 'Add to Bag';
        busy = true;
        if (spinner) spinner.style.display = 'block';
        if (label) label.textContent = 'Adding';
        addToCart(variantId, 1).then(function () {
          if (spinner) spinner.style.display = 'none';
          if (check) check.style.display = 'block';
          addBtn.style.background = 'var(--cls-accent)';
          if (label) label.textContent = 'Added to Bag';
          var name = addBtn.dataset.productName || 'Item';
          flash(name + (state.size ? ' · ' + state.size : '') + ' added to your bag');
          document.querySelectorAll('[data-cls-cart-count]').forEach(function (c) { c.textContent = (parseInt(c.textContent, 10) || 0) + 1; });
          setTimeout(function () {
            if (check) check.style.display = 'none';
            addBtn.style.background = '';
            if (label) label.textContent = basePrice;
            busy = false;
          }, 2600);
        }).catch(function () {
          if (spinner) spinner.style.display = 'none';
          if (label) label.textContent = basePrice;
          busy = false;
          window.location.href = '/cart';
        });
      });
    }

    /* Sticky bar + generic [data-clone-cta] buttons (rail quick-add, sticky ATC) */
    document.querySelectorAll('[data-clone-cta]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.dataset.productId;
        if (!id) { window.location.href = '/cart'; return; }
        addToCart(id, 1).then(function () {
          flash((btn.dataset.productName || 'Item') + ' added to your bag');
          document.querySelectorAll('[data-cls-cart-count]').forEach(function (c) { c.textContent = (parseInt(c.textContent, 10) || 0) + 1; });
        }).catch(function () { window.location.href = '/cart'; });
      });
    });

    /* ---------- Size guide drawer ---------- */
    var sgScrim = document.querySelector('[data-cls-sg-scrim]');
    var sgPanel = document.querySelector('[data-cls-sg-panel]');
    function openSizeGuide() { if (sgScrim) sgScrim.classList.add('is-open'); if (sgPanel) sgPanel.classList.add('is-open'); }
    function closeSizeGuide() { if (sgScrim) sgScrim.classList.remove('is-open'); if (sgPanel) sgPanel.classList.remove('is-open'); }
    document.querySelectorAll('[data-cls-open-sizeguide]').forEach(function (b) { b.addEventListener('click', openSizeGuide); });
    document.querySelectorAll('[data-cls-close-sizeguide], [data-cls-sg-scrim]').forEach(function (b) { b.addEventListener('click', closeSizeGuide); });

    /* ---------- Accordion ---------- */
    document.querySelectorAll('[data-cls-acc-item]').forEach(function (item) {
      var head = item.querySelector('[data-cls-acc-head]');
      if (!head) return;
      head.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        item.parentNode.querySelectorAll('[data-cls-acc-item]').forEach(function (i) { i.classList.remove('is-open'); i.querySelector('[data-cls-acc-head]').setAttribute('aria-expanded', 'false'); });
        if (!wasOpen) { item.classList.add('is-open'); head.setAttribute('aria-expanded', 'true'); }
      });
    });

    /* ---------- Rail arrows ---------- */
    document.querySelectorAll('[data-cls-rail-wrap]').forEach(function (wrap) {
      var rail = wrap.querySelector('[data-cls-rail]');
      if (!rail) return;
      var prev = wrap.querySelector('[data-cls-rail-prev]');
      var next = wrap.querySelector('[data-cls-rail-next]');
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -320, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: 320, behavior: 'smooth' }); });
    });

    /* ---------- Reviews: filter / sort / load more ---------- */
    var reviewList = document.querySelector('[data-cls-review-list]');
    if (reviewList) {
      var cards = Array.prototype.slice.call(reviewList.querySelectorAll('[data-cls-review-card]'));
      var perLoad = parseInt(reviewList.dataset.perLoad || '4', 10);
      var rState = { filter: 'all', sort: 'recent', shown: perLoad };

      function reviewMatches(card) {
        if (rState.filter === 'all') return true;
        if (rState.filter === 'photos') return card.dataset.hasPhoto === 'true';
        if (rState.filter === 'verified') return card.dataset.verified === 'true';
        return card.dataset.rating === rState.filter;
      }

      function sortCards(list) {
        var copy = list.slice();
        if (rState.sort === 'high') copy.sort(function (a, b) { return parseInt(b.dataset.rating, 10) - parseInt(a.dataset.rating, 10); });
        else if (rState.sort === 'helpful') copy.sort(function (a, b) { return parseInt(b.dataset.helpful || '0', 10) - parseInt(a.dataset.helpful || '0', 10); });
        else copy.sort(function (a, b) { return parseInt(b.dataset.order || '0', 10) - parseInt(a.dataset.order || '0', 10); });
        return copy;
      }

      var loadMoreWrap = document.querySelector('[data-cls-loadmore-wrap]');
      var loadMoreBtn = document.querySelector('[data-cls-loadmore-btn]');

      function render() {
        var filtered = sortCards(cards.filter(reviewMatches));
        cards.forEach(function (c) { c.classList.add('is-hidden'); reviewList.appendChild(c); });
        filtered.slice(0, rState.shown).forEach(function (c) { c.classList.remove('is-hidden'); reviewList.appendChild(c); });
        if (loadMoreWrap) loadMoreWrap.classList.toggle('is-hidden', filtered.length <= rState.shown);
      }
      render();

      document.querySelectorAll('[data-cls-filter-chip]').forEach(function (chip) {
        chip.addEventListener('click', function () {
          document.querySelectorAll('[data-cls-filter-chip]').forEach(function (c) { c.classList.remove('is-active'); });
          chip.classList.add('is-active');
          rState.filter = chip.dataset.filterKey;
          rState.shown = perLoad;
          render();
        });
      });

      var sortWrap = document.querySelector('[data-cls-sort-wrap]');
      var sortBtn = document.querySelector('[data-cls-sort-btn]');
      if (sortBtn) sortBtn.addEventListener('click', function () { sortWrap.classList.toggle('is-open'); });
      document.addEventListener('click', function (e) {
        if (sortWrap && !sortWrap.contains(e.target)) sortWrap.classList.remove('is-open');
      });
      document.querySelectorAll('[data-cls-sort-opt]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          document.querySelectorAll('[data-cls-sort-opt]').forEach(function (o) { o.classList.remove('is-active'); });
          opt.classList.add('is-active');
          rState.sort = opt.dataset.sortKey;
          if (sortBtn) sortBtn.querySelector('[data-cls-sort-label]').textContent = opt.textContent;
          sortWrap.classList.remove('is-open');
          render();
        });
      });

      if (loadMoreBtn) loadMoreBtn.addEventListener('click', function () { rState.shown += perLoad; render(); });
    }

    /* ---------- Sticky mobile ATC visibility ---------- */
    var stickyBar = document.querySelector('[data-cls-sticky-bar]');
    var heroEl = root.querySelector('[data-cls-purchase-anchor]');
    if (stickyBar && heroEl && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
      });
      io.observe(heroEl);
    }
    var stickyAddBtn = document.querySelector('[data-cls-sticky-add]');
    if (stickyAddBtn && addBtn) {
      stickyAddBtn.addEventListener('click', function () { addBtn.click(); });
    }

    /* ---------- Announcement bar close (shared with nav section, safe no-op if absent) ---------- */
  });
})();
